import { omit } from 'lodash';

export const convertContactToProfile = (contact) => {
  return omit(contact, function(value, key) {
    return key === 'id';
  });
}



// WEBPACK FOOTER //
// ./src/advocate/onboarding/reducers/profile_helpers.js